export enum KemPathsEnum {
  ROOT = "kem",
}

export enum KemRoutesEnum {
  ROOT = "/kem",
}
